export class ObjectUtil {
  static entries = <K extends string, T>(obj: {
    [Key in K]?: T;
  }) => {
    return Object.entries(obj) as [K, T][];
  };

  static keys = <K extends string>(obj: Partial<Record<K, any>>) => {
    return Object.keys(obj) as K[];
  };

  static values = <K extends string, T>(obj: Partial<Record<K, T>>) => {
    return Object.values(obj) as T[];
  };

  static getType = (arg: any) =>
    Object.prototype.toString.call(arg).slice(8, -1).toLowerCase() as 'string' | 'number' | 'array' | 'object' | string;

  static removeUndefined = <T>(val: T): T => {
    const type = ObjectUtil.getType(val);
    if (type === 'array') {
      return (val as unknown as any[]).map(v => ObjectUtil.removeUndefined(v)) as unknown as T;
    } else if (type === 'object') {
      return ObjectUtil.entries(val as Record<string, unknown>)
        .filter(([, v]) => v !== undefined)
        .reduce((res, [k, v]) => {
          res[k] = ObjectUtil.removeUndefined(v);
          return res;
        }, {} as Record<string, any>) as unknown as T;
    } else {
      return val;
    }
  };
}
